// src/components/Navbar.js
import React, { useState } from 'react';
import { USER_ROLES } from '../services/firebase';

const Navbar = ({ user, userRole, currentView, setCurrentView, handleLogout, onLogoClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavigation = (view) => {
    setCurrentView(view);
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (!user) {
      onLogoClick(); // Show admin login modal
    } else {
      handleNavigation('home'); // Go to home if already logged in
    }
  };

  // Only show admin/coordinator links if user has the appropriate role
  const showAdminLinks = userRole === USER_ROLES.ADMIN;
  const showMemberCoordinatorLinks = userRole === USER_ROLES.MEMBER_COORDINATOR;
  const showPartnerCoordinatorLinks = userRole === USER_ROLES.PARTNER_COORDINATOR;
  const showClubCoordinatorLinks = userRole === USER_ROLES.CLUB_COORDINATOR;

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <div className="logo-container" onClick={handleLogoClick} style={{cursor: 'pointer'}}>
          <img src="/favicon.jpg" alt="FMLC Logo" className="navbar-logo" />
          <span className="navbar-title">FMLC</span>
        </div>
        
        {/* Mobile menu button */}
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      
      <ul className={`nav-links ${isMobileMenuOpen ? 'nav-links-open' : ''}`}>
        <li>
          <button 
            className={currentView === 'home' ? 'active' : ''}
            onClick={() => handleNavigation('home')}
          >
            Home
          </button>
        </li>
        
        {user && (
          <>
            <li>
              <button 
                className={currentView === 'partner' ? 'active' : ''}
                onClick={() => handleNavigation('partner')}
              >
                Partner
              </button>
            </li>
            <li>
              <button 
                className={currentView === 'member' ? 'active' : ''}
                onClick={() => handleNavigation('member')}
              >
                Member
              </button>
            </li>
          </>
        )}
        
        {showAdminLinks && (
          <>
            <li>
              <button 
                className={currentView === 'admin' ? 'active' : ''}
                onClick={() => handleNavigation('admin')}
              >
                Admin
              </button>
            </li>
            <li>
              <button 
                className={currentView === 'role_manager' ? 'active' : ''}
                onClick={() => handleNavigation('role_manager')}
              >
                Role Manager
              </button>
            </li>
          </>
        )}
        
        {showMemberCoordinatorLinks && (
          <li>
            <button 
              className={currentView === 'member_coordinator' ? 'active' : ''}
              onClick={() => handleNavigation('member_coordinator')}
            >
              Member Coordinator
            </button>
          </li>
        )}
        
        {showPartnerCoordinatorLinks && (
          <li>
            <button 
              className={currentView === 'partner_coordinator' ? 'active' : ''}
              onClick={() => handleNavigation('partner_coordinator')}
            >
              Partner Coordinator
            </button>
          </li>
        )}
        
        {showClubCoordinatorLinks && (
          <li>
            <button 
              className={currentView === 'club_coordinator' ? 'active' : ''}
              onClick={() => handleNavigation('club_coordinator')}
            >
              Club Coordinator
            </button>
          </li>
        )}
      </ul>
      
      <div className="navbar-auth">
        {user ? (
          <div className="user-menu">
            <span className="user-info">
              <span className="user-name">{user.displayName || user.email}</span>
              {userRole && <span className="user-role">({userRole})</span>}
            </span>
            <button onClick={handleLogout} className="btn-logout">
              Logout
            </button>
          </div>
        ) : (
          <div className="auth-buttons">
            <button onClick={() => handleNavigation('login')} className="btn-login">
              Login
            </button>
            <button onClick={() => handleNavigation('register')} className="btn-register">
              Register
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;